import reducer from './reducer'
import * as unsavedChangesActions from './actions'
import * as unsavedChangesSelectors from './selectors'

export { unsavedChangesActions, unsavedChangesSelectors }

export default reducer
